const FAQ = [
  {
    question: "How long does a complete home remodel take?",
    answer:
      "Timelines vary by project size and scope. Most full home remodels<IN_CITY_ZIP> take 4 to 8 months, including design, permitting, demolition, and construction. We provide a detailed schedule before we begin.",
  },
  {
    question: "What’s the average cost for a full home remodel?",
    answer:
      "A complete home remodel<IN_CITY_ZIP> typically starts around $150,000 and can exceed $500,000 depending on square footage, material choices, and structural changes. We provide detailed, custom estimates during your consultation.",
  },
  {
    question: "Do I need to move out during a full home renovation?",
    answer:
      "In many cases, yes — especially if the remodel<IN_CITY_ZIP> impacts kitchens, bathrooms, HVAC, or electrical systems. We help you plan for minimal disruption and determine if temporary relocation is recommended.",
  },
  {
    question: "Will you handle design, permits, and city approvals?",
    answer:
      "Yes. As a full-service design-build contractor<IN_CITY_ZIP>, Modern Build manages architectural plans, interior design, material sourcing, permits, and city inspections from start to finish.",
  },
  {
    question: "Can I customize my remodel to fit my lifestyle?",
    answer:
      "Absolutely. Every remodel<IN_CITY_ZIP> is tailored to your needs — whether you want an open-concept floorplan, chef’s kitchen, luxury suite, dedicated home office, or smart home integration.",
  },
  {
    question: "Do you offer financing for full home remodels?",
    answer:
      "Yes. We offer flexible financing options<IN_CITY_ZIP> including $0 down and terms up to 15 years. Our team will help you explore pre-approval programs that fit your budget and timeline.",
  },
  {
    question: "Why choose Modern Build for my home renovation?",
    answer:
      "Modern Build delivers personalized full home remodels<IN_CITY_ZIP> with expert craftsmanship, transparent pricing, and professional project management — all under one roof.",
  },
  {
    question: "Can I remodel my home in phases?",
    answer:
      "Yes. If you’d prefer to remodel in stages<IN_CITY_ZIP> — such as starting with the kitchen, then tackling bathrooms or bedrooms later — we’ll develop a phased plan that keeps your budget and future goals aligned.",
  },
  {
    question: "What upgrades add the most value to a home remodel?",
    answer:
      "High-ROI upgrades<IN_CITY_ZIP> include custom kitchens, spa-style bathrooms, open-concept layouts, energy-efficient HVAC and windows, and curb appeal improvements like modern exterior finishes.",
  },
  {
    question: "Do you work with older or historic homes?",
    answer:
      "Yes. We specialize in updating older homes<IN_CITY_ZIP> while preserving their character. From code upgrades to structural retrofits, we bring experience navigating the unique challenges of vintage and historic properties.",
  },
];

export default FAQ;
